<template>
  <div
    class="ac-menu-compo"
  >
    <!-- 搜索提示 -->
    <div
      :class="`abs switch-tips ${isShrink ? '': 'expand'}`"
      @click="isShrink=!isShrink"
    >
      {{ isShrink ? '展开图片' : '收起图片' }}
    </div>
    <!-- 切换标签 -->
    <div class="tag-info-view">
      <div
        v-show="tagInfo.length > 0"
        :style="`height: ${!showTag ? '0' : '34'}px`"
        :class="`tag-view ${tagInfo.length < 5 ? 'flx-ctr' : 'flx-row-str'} animated1s ${showTag ? 'fadeInUp' : 'fadeOutDown'}`"
      >
        <div
          v-for="(item, index) in tagInfo"
          :id="`tag-${index}`"
          :key="`tag-${item.group}-${index}`"
          :class="['tag flx-ctr fade-ani', item.group == group ? 'select-tag' : '']"
          @click="onChangeGroup(item.group, index)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <div
      :class="`menu ${info.length > 5 ? 'flx-row-str' : 'flx-ctr'}`"
      :style="`height: ${isShrink ? '0' : '75'}px`"
    >
      <van-image
        v-for="item in info"
        :id="`item-${item.id}`"
        :key="`item-${item.id}`"
        :class="['item fade-ani', value == item.id ? 'select' : '']"
        :width="`${options.width}px`"
        :height="`${options.height}px`"
        :show-error="false"
        :show-loading="false"
        :src="item.src"
        @click="onChange(item.id)"
      >
        <span class="text flx-ctr">
          {{ item.text }}
        </span>
      </van-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        width: 54,
        height: 54,
      }),
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    tagInfo: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Number,
      default: 1,
    },
    value: {
      type: String,
      default: '01',
    },
  },
  data() {
    return {
      isShrink: false,
    };
  },
  computed: {
    contentWidth() {
      const { isShrink, options, info } = this;
      return isShrink ? 0 : (options.width + 12) * info.length;
    },
  },
  watch: {
    value(id) {
      this.scrollIntoView(id);
      // this.$refs[refName][0].scrollIntoView();
    },
  },
  methods: {
    onShrink() {
      this.isShrink = !this.isShrink;
    },
    onChange(id) {
      this.$emit('onChange', id);
    },
    onChangeGroup(group, index) {
      if (index > 2) {
        this.scrollIntoView(7);
      } else {
        this.scrollIntoView(0);
      }
      this.$emit('onChangeGroup', group);
    },
    scrollIntoView(id) {
      this.$nextTick(() => {
        document.getElementById(`tag-${id}`).scrollIntoView({ behavior: 'smooth' });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ac-menu-compo {
  background-color: rgba(0, 0, 0, .5);
  transition: width 0.6s ease 0s;
  text-align: center;
  // padding: 8px 5px;
  width: 10rem;
  .switch-tips {
    display: inline-block;
    width: 76px;
    height: 24px;
    top: -28px;
    left: 10px;
    color: #fff;
    line-height: 24px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.8);
    padding-left: 20px;
    box-sizing: border-box;
    overflow: hidden;
    margin-right: 8px;
    border-radius: 2px;
    &::after {
      content: '';
      position: absolute;
      top: 9px;
      left: 8px;
      width: 0;
      height: 0;
      border-width: 5px;
      border-style: solid;
      border-color: transparent;
      border-top-color: #D0D0D0;
    }
    &.expand::after {
      border-top-color: transparent;
      border-bottom-color: #D0D0D0;
      top: 4px;
    }
  }
  .tag-info-view {
    width: calc(10rem - 10px);
    padding: 0 5px;
    overflow: hidden;
  }
  .tag-view {
    width: 100%;
    overflow-x: scroll;
    height: 38px;
    color: #fff;
    font-size: 12px;
    transition: height 0.5s ease-in-out;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .tag {
      margin: 0 6px;
      white-space: nowrap;
      &.select-tag {
        color: #f4c06f;
      }
    }
  }
  .menu {
    width: 100%;
    height: 74px;
    white-space: nowrap;
    overflow-x: scroll;
    border-top: 1px solid rgba(255,255,255,0.3);
    box-sizing: content-box;
    transition: height 0.5s ease-in-out;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
  .item {
    flex-shrink: 0;
    margin: 0 10px;
    &.select {
      box-shadow: 0px 0 5px 0px rgba(255,255,255,1);
      border-image: linear-gradient(128deg, rgba(255,255,255,1), rgba(255,255,255,1)) 1 1;
    }
    .text {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 20px;
      background-color: rgba(0, 0, 0, .7);
      color: #fff;
      font-size: 10px;
    }
  }
}
</style>
